<template>
  <v-card>
    <v-card-text>
      <mover
        :leftTitle="`Group `"
        :rightTitle="`Chọn `"
        :datasource="groups"
        :outputDatasource="userGroup"
        :firstLineProp="`name`"
        :secondLineProp="`remark`"
        @output="getSelectedRole($event)"
      />
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="close">Hủy</v-btn>
      <v-btn color="primary" dark @click="setRoleSubmit" :loading="loading">Cập nhật</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Mover from '@/components/mover';
import { mapActions } from 'vuex';
export default {
  components: {
    Mover
  },

  props: {
    user: {
      type: Object,
      default: null
    },
  },

  data () {
    return {
      groups: [],
      userGroup: [],
      selectedRoles: [],
      loading: false
    };
  },
  async created () {
    let groups = await this.getGroupRoles();
    if (Array.isArray(groups) && this.user) {
      let left = [];
      let right = [];
      let groupIds = groups.map(a => a.id);
      let userGroupIds = (this.user.groupRoles || []).map(a => a.groupId);

      groupIds.map(a => {
        let group = groups.filter(b => b.id === a)[0];

        if (userGroupIds.includes(a)) right.push(group);
        else left.push(group);

        return 0;
      });

      this.groups = left;
      this.userGroup = right;
    }
  },
  methods: {
    ...mapActions(['getGroupRoles', 'setRoles']),
    getSelectedRole (roles) {
      this.selectedRoles = roles;
    },
    close () {
      this.$emit('show', false);
    },
    async setRoleSubmit () {
      this.loading = true;
      try {
        let model = {
          userId: this.user.id,
          groupRoles: this.selectedRoles.map(a => a.id)
        };
        let res = await this.setRoles(model);
        if (res) {
          window.getApp.showMessage('Cập nhật thành công');
          this.$emit('show', false);
          setTimeout(() => {
            window.location.reload();
          }, 500);
        }
      } catch (error) {
        console.log(error);
        window.getApp.showMessage(error, 'error');
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/account/components/Role.vue